import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm$items, _vm$currentItem, _vm$currentItem2, _vm$currentItem3, _vm$currentItem4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "actions-top-line"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      disabled: _vm.remainingAmount <= 0 || _vm.isForcedToHaveOnePaymentMax && ((_vm$items = _vm.items) === null || _vm$items === void 0 ? void 0 : _vm$items.length) > 0,
      rounded: ""
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.addPayment();
      }
    }
  }, [_c("i", {
    staticClass: "fas fa-plus",
    staticStyle: {
      "margin-right": "0.2rem"
    }
  }), _vm._v(" Add Payment ")])], 1), _vm.isForcedToHaveOnePaymentMax ? _c("div", {
    staticClass: "text-right text-smaller text-italic"
  }, [_vm.hasAnyOldStockTransferAttached ? [_vm._v(" This order dispatch is linked to an old version of container orders. "), _c("br")] : _vm._e(), _vm._v(" There must be a single payment for the total amount of the order dispatch, for accounting purposes. ")], 2) : _vm._e(), _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      id: "table-inbound-payments",
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.state",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c(VMenu, {
          key: item.state,
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            disabled: !item.failReason
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c("div", {
                staticClass: "flex"
              }, [item.state && _vm.paymentState ? _c("div", _vm._g(_vm._b({
                staticClass: "badge",
                class: [[_vm.stateStyleClass()[item.state]]]
              }, "div", attrs, false), on), [_c("span", [_vm._v(" " + _vm._s(_vm.getPublicPaymentStateForAdmins(item.state)) + " " + _vm._s(_vm.inboundDelivery.buyerTerm && item.state === _vm.paymentState.DEFERRED ? "- ".concat(_vm.listTerms.find(function (x) {
                return x.id === _vm.inboundDelivery.buyerTerm;
              }).name) : null) + " ")]), [item.state === _vm.paymentState.SUCCEEDED ? [_c("i", {
                staticClass: "fas fa-check"
              }), !!item.paymentDate ? _c("span", [_vm._v("   " + _vm._s(_vm._f("formatDate")(item.paymentDate)) + " ")]) : _vm._e()] : _vm._e(), item.state === _vm.paymentState.PROCESSING ? _c("i", {
                staticClass: "fas fa-clock"
              }) : _vm._e(), item.state === _vm.paymentState.ACKNOWLEDGED ? _c("i", {
                staticClass: "fas fa-clock"
              }) : _vm._e(), item.state === _vm.paymentState.DEFERRED ? _c("i", {
                staticClass: "fas fa-clock"
              }) : _vm._e(), item.state === _vm.paymentState.FAILED ? _c("i", {
                staticClass: "fas fa-times"
              }) : _vm._e()], item.reference ? _c("div", {
                staticClass: "text-smaller text-italic",
                staticStyle: {
                  "margin-top": "-0.5rem"
                }
              }, [_vm._v(" #" + _vm._s(item.reference) + " ")]) : _vm._e()], 2) : _vm._e()])];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", [_vm._v(_vm._s(item.failReason))])])], 1), item.isLaunchingPayment ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" Syncing with Stripe payment ... ")]) : _vm._e(), !item.state ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" Payment verification is automatically carried out on a daily basis. ")]) : _vm._e()], 1)];
      }
    }, {
      key: "item.type",
      fn: function fn(_ref3) {
        var _item$link;
        var item = _ref3.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.typeLabel) + " "), _c("span", {
          staticClass: "text-smaller text-italic"
        }, [item.type !== _vm.paymentTypesWithCN.find(function (x) {
          return x.name === "Credit note";
        }).id ? [_vm._v(" (" + _vm._s(item.methodId ? "stripe" : "external") + ") ")] : _vm._e()], 2)]), item.microDepositsUrl ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_c("a", {
          attrs: {
            href: _vm.payment.microDepositsUrl,
            target: "_blank"
          }
        }, [_vm._v("Micro-deposits link")])]) : _vm._e(), (_item$link = item.link) !== null && _item$link !== void 0 && _item$link.stripeUrl ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_c("a", {
          attrs: {
            href: item.link.stripeUrl,
            target: "_blank"
          }
        }, [_vm._v("Payment link")])]) : _vm._e()];
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(item.amount)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [item.type === _vm.paymentTypesWithCN.find(function (x) {
          return x.name === "Credit note";
        }).id ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, [_vm._v(" Use credit note features ")]) : _c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [_c("div", {
          staticClass: "flex gap-3 justify-center"
        }, [_vm.isPaymentEditable(item) ? _c(VIcon, {
          attrs: {
            loading: item.isLaunchingPayment,
            disabled: !_vm.isLaunchPaymentAvailable(item) || !_vm.isPaymentEditable(item),
            title: "Launch stripe payment",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.launchPayment(item);
            }
          }
        }, [_vm._v(" fa fa-play ")]) : _vm._e(), _vm.isPaymentEditable(item) ? _c(VIcon, {
          attrs: {
            rounded: "",
            disabled: item.isLaunchingPayment || !item.isSendPaymentLinkAvailable || !_vm.isPaymentEditable(item),
            title: "Send payment link",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.createPaymentLink(item);
            }
          }
        }, [_vm._v(" fas fa-paper-plane ")]) : _vm._e(), _vm.isPaymentEditable(item) ? _c(VIcon, {
          attrs: {
            disabled: item.isLaunchingPayment,
            title: "Edit payment",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.editPayment(item);
            }
          }
        }, [_vm._v(" fas fa-edit ")]) : _c(VIcon, {
          attrs: {
            disabled: item.isLaunchingPayment,
            title: "Correct payment data",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.changePaymentStatus(item);
            }
          }
        }, [_vm._v(" fas fa-eye ")]), _vm.isPaymentEditable(item) ? _c(VIcon, {
          attrs: {
            disabled: item.isLaunchingPayment || !_vm.isPaymentEditable(item),
            title: "Remove payment",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.removePayment(item);
            }
          }
        }, [_vm._v(" fa fa-trash ")]) : _vm._e()], 1)])])];
      }
    }], null, true)
  }), _vm._m(0), _vm.inboundDeliveryPaymentDetailsDialogShown ? _c("InboundDeliveryPaymentDetailsDialog", {
    attrs: {
      dialog: _vm.inboundDeliveryPaymentDetailsDialogShown,
      loggedUserData: _vm.loggedUserData,
      payment: _vm.currentItem,
      inboundDelivery: _vm.inboundDelivery
    },
    on: {
      close: function close() {
        return _vm.inboundDeliveryPaymentDetailsDialogShown = false;
      },
      validate: function validate(_, ack) {
        _vm.refetchPayments(ack);
      }
    }
  }) : _vm._e(), _c("PaymentChangeStatusDialog", {
    attrs: {
      dialog: _vm.paymentDialogStatusShown,
      paymentStatus: (_vm$currentItem = _vm.currentItem) === null || _vm$currentItem === void 0 ? void 0 : _vm$currentItem.state,
      reference: (_vm$currentItem2 = _vm.currentItem) === null || _vm$currentItem2 === void 0 ? void 0 : _vm$currentItem2.reference,
      paymentIdType: (_vm$currentItem3 = _vm.currentItem) === null || _vm$currentItem3 === void 0 ? void 0 : _vm$currentItem3.type,
      successDate: (_vm$currentItem4 = _vm.currentItem) === null || _vm$currentItem4 === void 0 ? void 0 : _vm$currentItem4.paymentDate,
      confirm: _vm.updatePaymentStatus,
      cancel: function cancel() {
        return _vm.showPaymentStatusDialog(false);
      }
    }
  }), _c("PaymentLinkDrawer", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isShown: _vm.paymentLinkDrawerShown,
      payment: _vm.currentItem
    },
    on: {
      close: function close() {
        return _vm.paymentLinkDrawerShown = false;
      },
      validate: function validate(_, ack) {
        _vm.refetchPayments(ack);
      }
    }
  }), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tip mt-2"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" You can download the "), _c("strong", [_vm._v("Sum-up invoices")]), _vm._v(" file in the documents. ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };